// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 443 ? "about" : chunkId) + "." + {"417":"395bc2ac","443":"2edb033d","478":"aab37c0b","705":"573bac1e"}[chunkId] + ".js";
};